<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputEmail" });
import { Input } from "../../../../inputs/index.js";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = true;
export let placeholder = "resource.user.properties.email.placeholder";
</script>

<Input
    bind:value
    autocomplete = 'email'
    keyboard = 'email'
    label = 'resource.user.properties.email.label'
    name = 'user.email'
    type = 'email'
    { placeholder }
    { isDisabled }
    { isReadonly }
    { isRequired }
/>